import { useState } from "react";
import { s } from "../lib/constants";

export default function HomeScreen({ onNew, onHaveCode }) {
  const [name, setName] = useState("");

  return (
    <div style={s.step}>
      <p style={s.eyebrow}>relation stamp</p>
      <p style={s.display}>What kind of connection<br />are you two?</p>
      <p style={s.body}>
        Two people answer five quick questions about each other — independently.
        The AI reads both sides and tells you what kind of connection you have.
      </p>
      <input
        style={s.input}
        type="text"
        value={name}
        onChange={e => setName(e.target.value)}
        placeholder="Your first name"
        maxLength={30}
      />
      <div style={s.btnRow}>
        <button
          style={{ ...s.btnPrimary, opacity: name.trim() ? 1 : 0.4 }}
          onClick={() => name.trim() && onNew(name.trim())}
          disabled={!name.trim()}
        >
          Start new session
        </button>
        <button
          style={{ ...s.btnSecondary, opacity: name.trim() ? 1 : 0.4 }}
          onClick={() => name.trim() && onHaveCode(name.trim())}
          disabled={!name.trim()}
        >
          Join with code
        </button>
      </div>
    </div>
  );
}
